// 保留旧模板字段作为回退，新增字段由字段管理接口提供。
export const traceFields = [
  { value: 'fwcode_sn', label: '溯源编码', defaultText: '91440106696938899' },
  { value: 'product_name', label: '产品名称', defaultText: '金龙鱼 东北大米 5kg 乳玉皇妃稻香贡米...' },
  { value: 'batch_sn', label: '生产批次', defaultText: '001' },
  { value: 'server_phone', label: '服务电话', defaultText: '13012345678' },
  { value: 'server_title', label: '服务信息', defaultText: '华南营销中心' },
  { value: 'sale_area', label: '销售区域', defaultText: '广东省/广州市/天河区' },
  { value: 'inspection_report', label: '检验报告' },
  { value: 'video', label: '监控视频直播' },
  { value: 'video_is_show', label: '产品介绍' },
];

export const enterpriseFields = [
  { value: 'enterpriseInfo', label: '企业信息' },
  { value: 'company_bar_code', label: '组织机构代码', defaultText: '91440106696938899' },
  { value: 'company_license_no', label: '营业执照代码', defaultText: '91440106696938899' },
  { value: 'company_business_addr', label: '企业地址', defaultText: '广州市天河区棠安路288-298号' },
];

export const fieldKey = (field) => field.value || field.key || field.id;
export const sameKey = (left, right) => String(left) === String(right);

export const uniqueKeys = (keys = []) => keys.filter(
  (key, index) => keys.findIndex((item) => sameKey(item, key)) === index
);

// 元数据优先使用字段管理保存的值，同时兼容只有 showKey / data 的旧模板。
const previewFields = (data, defaults) => {
  const params = data.params || {};
  const sources = [defaults, data.data, params.data, params.fieldList, params.sysFieldList];
  return uniqueKeys(params.showKey || []).map((key) => {
    const field = sources.reduce((result, rows) => {
      const match = (Array.isArray(rows) ? rows : []).find((row) => sameKey(fieldKey(row), key));
      return match ? { ...result, ...match } : result;
    }, {});
    return {
      ...field,
      key,
      label: field.customerTitle || field.label || '自定义字段',
      defaultText: field.customerValue !== undefined && field.customerValue !== null && field.customerValue !== ''
        ? field.customerValue : (field.defaultText || (['inspection_report', 'video', 'video_is_show'].includes(key) ? '' : '内容')),
    };
  });
};

export const tracePreviewFields = (data) => previewFields(data, traceFields);

export const enterprisePreviewFields = (data) => previewFields(data, [
  ...enterpriseFields,
  // 新版接口将企业信息拆为独立字段；旧模板继续使用 enterpriseInfo。
  { value: 'enterpriseLogo', label: '企业Logo' },
  { value: 'enterpriseName', label: '企业名称', defaultText: 'xxxxxxx有限公司' },
  { value: 'enterpriseAliasName', label: '公司别称', defaultText: '公司别称' },
  { value: 'enterprisePhone', label: '客服电话', defaultText: '400-8381186' },
  { value: 'enterpriseBrandName', label: '品牌名称', defaultText: '品牌名称' },
  { value: 'organization', label: '组织机构代码', defaultText: '91440106696938899' },
  { value: 'business', label: '营业执照代码', defaultText: '91440106696938899' },
  { value: 'address', label: '企业地址', defaultText: '广州市天河区棠安路288-298号' },
]);
